import React from "react";

/**
 * Around the lazily loaded results dashboard (/event-results/:id) only. If
 * its code can't be downloaded (venue Wi-Fi drops as the tab opens) or the
 * page throws while rendering, the admin gets a message and a Reload button
 * instead of a blank tab. Loaded with the main bundle, so it styles itself
 * with the app's own classes, not the dashboard's stylesheet.
 */
export default class ResultsRouteBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error("event-results: the dashboard failed to load or render", error, info?.componentStack);
    }

    render() {
        const { error } = this.state;
        if (!error) return this.props.children;
        const chunk = error?.name === "ChunkLoadError" || /Loading (CSS )?chunk/i.test(String(error?.message || ""));
        return (
            <div className="w-full h-screen flex-center" role="alert">
                <div className="flex flex-col items-center gap-3 text-center px-4">
                    <p className="text-lg font-bold">Couldn't load the results dashboard</p>
                    <p className="text-sm opacity-70">
                        {chunk ? "Check the connection, then reload the page." : "Something went wrong. Reload the page to try again."}
                    </p>
                    <button type="button" className="btn btn-sm" onClick={() => window.location.reload()}>
                        Reload
                    </button>
                </div>
            </div>
        );
    }
}
